module.exports = __webpack_public_path__ + "img/44.8.TSS.7dadaa95.png";